export default "__VITE_ASSET__8ada310a__"